import React from 'react';
import { motion } from 'framer-motion';

const projects = [
  {
    title: 'YouTube Thumbnail – Criminals',
    image: '/criminal.jpg',
    link: '#',
  },
  {
    title: 'Thumbnail – Investment',
    image: '/invest.png',
    link: '#',
  },
  {
    title: 'financial Thumbnail',
    image: '/rise.png',
    link: '#',
  },
  {
    title: 'war Thumbnail',
    image: '/war.jpg',
    link: '#',
  },
];

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      className="p-8 bg-white max-w-6xl mx-auto"
    >
      <h2 className="text-3xl font-semibold mb-6 text-center text-indigo-900">Portfolio Youtube Thumbnail</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {projects.map((project, index) => (
          <motion.div
            key={index}
            className="bg-gray-100 rounded-xl overflow-hidden shadow-lg cursor-pointer"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            whileHover={{ scale: 1.05, boxShadow: '0 0 15px rgba(99, 102, 241, 0.7)' }}
          >
            <img src={project.image} alt={project.title} className="w-full h-48 object-cover" />
            <div className="p-5">
              <h3 className="text-xl font-bold mb-3 text-indigo-900">{project.title}</h3>
              <a href={project.link} className="text-indigo-600 hover:underline font-semibold">
                View Project
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
